import { main } from './main/index'

main().then(app => app.mount('#app'))
